var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "s-toggle",
      class: {
        "s-toggle--checked": _vm.value,
        "s-toggle--disabled": _vm.disabled,
      },
    },
    [
      _c("input", {
        attrs: { type: "checkbox", disabled: _vm.disabled, hidden: "" },
        domProps: { value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event.target.checked)
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }